<template>
<div class="box-labourParticulars">
    <div class="nav">
        <router-link to="AdministrativeHome"><img src="../../assets/up.png" alt="" class="upClass"></router-link>
        常见场景
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item,i) in dataList" :key="i">
                <div class="labourParticulars labourParticulars-active">
                    <img :src="item.image" alt="" class="QRcodeImg">
                    <h6 v-if="item.page != 1" @click="addGetrequer(item.page,item.code)">了解更多</h6>
                    <img v-if="i!=2" src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
  data() {
    return {
      fingerprintShow: false,
      flowShow: false,
      agreementShow: false,
      dataList:[{image:"http://file.xdf.cn/uploads/191031/1369_20191031135033.jpg", page:'1', code:''},
        {image:"http://file.xdf.cn/uploads/191031/1369_20191031135220.jpg", page:'Administrative8', code:''},  // 会议相关预订申请流程11
        {image:"http://file.xdf.cn/uploads/191031/1369_20191031135307.jpg", page:'Administrative4', code:''}], // 会议配套周边预订流程 12
    };
  },
  methods: {
    getOnPage() {
            this.$router.push({
                name: 'Search',
                params: {
                    code: "q"
                }
            })
        },
        addGetrequer(page,i){
          this.$router.push({name:page,params:{code:i}})
        }
  },
  mounted() {
    var mySwiper = new Swiper(".swiper-container", {
      direction: "vertical",
    });
  }
};
</script>

<style>
.swiper-container {
  width: 100%;
  height: 100%;
}

.box-labourParticulars {
  width: 100%;
  height: 100%;
  background: rgba(244, 244, 244, 1);
  overflow: hidden;
}

.nav {
  width: 100%;
  height: 50px;
  background: #11a093;
  text-align: center;
  line-height: 50px;
  color: #ffffff;
  position: relative;
  margin-bottom: 17px;
}

.upClass,
.searchClass {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
}

.upClass {
  width: 12px;
  float: left;
  left: 10px;
}

.searchClass {
  width: 19px;
  float: right;
  right: 10px;
}

.labourParticulars {
  width: 90%;
  height: 83%;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
  border-radius: 11px;
  position: relative;
  overflow: hidden;
}

.labourParticulars-active {
  padding-top: 0 !important;
}

.labourParticulars .labourParticulars-title {
  text-align: center;
  font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
  margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
  display: block;
  line-height: 30px;
  margin-left: 16px;
  margin-right: 16px;
  color: #888787;
  font-size: 14px;
}

.labourParticulars .spanClass {
  text-indent: 30px;
}
h6{
    font-size: 14px;
    color: red;
    position: absolute;
    right: 20px;
    bottom: 6%;
}
.title-box {
  padding: 0 0 5% ;
  font-size: 16px
}

.labourParticulars_bottomImg {
  width: 15%;
  display: block;
  left: 0;
  right: 0;
  margin: auto;
  position: absolute;
  bottom: 12px;
}

.QRcodeImg {
    width: 100% !important;
    height: 90%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/pageScene/scene3.vue